import React from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';

export const PendingAccessPage: React.FC<{ email: string | null; hasError: boolean }> = ({ email, hasError }) => {
  const navigate = useNavigate();
  const handleSignOut = async () => {
    await authService.signOutUser();
    navigate('/login', { replace: true });
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-50 px-4 py-10 dark:bg-gray-900">
      <section className="w-full max-w-lg rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-xl dark:border-gray-700 dark:bg-gray-800 sm:p-10">
        <div className="mx-auto grid h-16 w-16 place-items-center rounded-full bg-amber-100 text-3xl" aria-hidden="true">⌛</div>
        <p className="mt-6 text-xs font-bold tracking-[0.18em] text-teal-700 dark:text-teal-300">BFGC · 행정 포털</p>
        <h1 className="mt-2 text-2xl font-bold text-gray-900 dark:text-white">권한 인증이 필요합니다</h1>
        <p className="mt-3 break-all text-sm text-gray-500 dark:text-gray-300">{email}</p>
        {hasError ? (
          <div role="alert" className="mt-6 rounded-xl bg-rose-50 p-4 text-left text-sm leading-6 text-rose-900">권한 정보를 확인하지 못했습니다. 권한을 부여하지 않은 상태로 처리했어요. 연결을 확인한 뒤 다시 로그인해 주세요.</div>
        ) : (
          <p className="mt-6 rounded-xl bg-amber-50 p-4 text-left text-sm leading-6 text-amber-950">로그인은 되었지만 행정 포털 권한은 아직 부여되지 않았어요. 회원 정보와 권한은 행정 관리자 화면에서 별도로 관리됩니다.</p>
        )}
        <button type="button" onClick={() => void handleSignOut()} className="mt-7 min-h-11 w-full rounded-xl bg-[#1d4147] px-5 py-3 text-sm font-semibold text-white hover:bg-[#16363b]">로그아웃</button>
      </section>
    </main>
  );
};
